import React from 'react';
import { Theme, ThemedStyles, useStyles } from 'ui/base/theme';
import baseStyles from './add_pangolin_page.module.css';


type AddPangolinPageStyles = {
  background: string;
  container: string;
};

const themedStyles: ThemedStyles<AddPangolinPageStyles> = {
  [Theme.DAYLIGHT]: {
    background: baseStyles.daylightBackground,
    container: baseStyles.container,
  },
  [Theme.MIDNIGHT]: {
    background: baseStyles.midnightBackground,
    container: baseStyles.container,
  },
};

export type AddPangolinPageProps = {
  children: React.ReactNode;
};

export const AddPangolinPage = React.memo(({ children }: AddPangolinPageProps) => {
  const styles = useStyles(themedStyles);
  return (
    <div className={styles.background}>
      <div className={styles.container}>
        {children}
      </div>
    </div>
  );
});

AddPangolinPage.displayName = 'AddPangolinPage';
